"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _Global = _interopRequireDefault(require("@rsuite/icon-font/lib/network/Global"));

// Generated by script, don't edit it please.
var Global = (0, _createSvgIcon["default"])({
  as: _Global["default"],
  ariaLabel: 'global',
  category: 'network',
  displayName: 'Global'
});
var _default = Global;
exports["default"] = _default;
module.exports = exports.default;